module.exports = {
  "persistFilters": [],
  "persistKeys": [],
  "useSentryMiddleware": true
};